<template lang="">
  <el-menu background-color="#545c64" text-color="#fff" class="el-menu-TopNav">
    <div class="content">
      <el-image
        :src="logo"
        fit="contain"
        style="margin-left: 70px; height: 80px"
        @click="HomePage"
      ></el-image>
      <i class="el-icon-info" style="color: white" v-show="pageWidth > 768">
        该网页搭配微信小程序使用 微信搜索“shishi鉴别”</i
      >
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          <el-avatar :size="60"> {{ UserName }} </el-avatar>
          <i class="el-icon-arrow-down el-icon--right" style="color: #fff"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item disabled>{{
            jurisdiction == 1 ? "鉴定师" : "超级管理员"
          }}</el-dropdown-item>
          <el-dropdown-item divided @click.native="ChangePwd"
            >更改密码</el-dropdown-item
          >
          <!-- <el-dropdown-item divided @click.native="SwitchAccounts"
            >切换账号</el-dropdown-item
          > -->
          <el-dropdown-item @click.native="ExitAccount"
            >退出账号</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-menu>
</template>
<script>
import { CheckToken } from "@/api/index.js";
import * as auth from "@/utils/auth";
export default {
  name: "TopNav",
  data() {
    return {
      logo: "/logo.png",
      UserName: "Admin",
      jurisdiction: "",
      pageWidth: document.documentElement.clientWidth,
    };
  },
  methods: {
    HomePage() {
      this.$router.push("/");
    },
    // 修改密码
    ChangePwd() {
      this.$router.push("/UserSettings/ChangePassword");
    },
    // 切换账号
    // SwitchAccounts() {
    //   this.$router.push("/Login");
    // },
    // 退出账号
    ExitAccount() {
      auth.removeAdminInfo();
      this.$router.push("/Login");
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.pageWidth = document.documentElement.clientWidth;
    });
    this.$nextTick(() => {
      const admin = auth.getAdminInfo();
      if (!admin || admin.code !== 200) {
        auth.removeAdminInfo();
        this.$router.push("/login");
        return;
      }

      CheckToken(admin.data.token).then((res) => {
        if (res.code !== 200) {
          auth.removeAdminInfo();
          this.$router.push("/login");
        }
      });

      this.UserName = admin.data.userInfo.name;
      this.jurisdiction = admin.data.userInfo.type;
      // if (auth.getAdminInfo("adminInfo")[1] == "") this.UserName = "Admin";
      // else this.UserName = auth.getAdminInfo("adminInfo")[1];
    });
  },
};
</script>
<style scoped>
/* 顶部导航栏 */
.el-menu-TopNav {
  /* height: 80px !important; */
  z-index: 1500;
}

.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-dropdown-link {
  margin-right: 40px;
  display: flex;
  align-items: center;
}
</style>
